import { useState, useRef, useEffect } from 'react';

export default function useRecordingTimer() {
  const [elapsedTime, setElapsedTime] = useState(0);
  const timerRef = useRef(null);

  const start = () => {
    if (!timerRef.current) {
      timerRef.current = setInterval(() => {
        setElapsedTime(prev => prev + 1);
      }, 1000);
    }
  };

  const pause = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  const reset = () => {
    pause();
    setElapsedTime(0);
  };

  useEffect(() => {
    return () => pause(); // cleanup on unmount
  }, []);

  return { elapsedTime, start, pause, reset };
}